export const RemoveNearestTrendCursorActionType = 'REMOVE_NEAREST_TREND_CURSOR';
export const removeNearestTrendCursor = (event, chartId) => ({
    type: RemoveNearestTrendCursorActionType,
    event,
    chartId,
});
